/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayoutRequestDto { 
    id: string;
    organizerId: string;
    organizerName: string;
    organizerEmail: string;
    organizerAvatarUrl?: string;
    amount: number;
    status: PayoutRequestDto.StatusEnum;
    requestedAt: string;
    approvedAt?: string;
    approvedBy?: string;
    processedAt?: string;
    paidAt?: string;
    stripePayoutId?: string;
    failureReason?: string;
    events: Array<string>;
    connectedAccountStatus: string;
    /** The VAT status the pro declared, null while missing: approval is then refused. */
    vatStatus?: PayoutRequestDto.VatStatusEnum | null;
}
export namespace PayoutRequestDto {
    export type VatStatusEnum = 'vat_registered' | 'franchise' | 'association';
    export type StatusEnum = 'pending' | 'approved' | 'in_transit' | 'paid' | 'declined' | 'failed' | 'canceled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Approved: 'approved' as StatusEnum,
        InTransit: 'in_transit' as StatusEnum,
        Paid: 'paid' as StatusEnum,
        Declined: 'declined' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Canceled: 'canceled' as StatusEnum
    };
}


